import { computed, ref } from 'vue'

import { defineStore } from 'pinia'

import { isBetaPreviewEnabled } from '../utils/show-beta-preview-url.utils'

export const useBetaPreviewUIStore = defineStore('beta-preview-ui', () => {
  const showBetaPreview = ref<string | null>(null)

  const isShowBetaPreviewEnabled = computed(() => isBetaPreviewEnabled(showBetaPreview.value))

  function setShowBetaPreview(value: string | null) {
    showBetaPreview.value = value
  }

  function clearShowBetaPreview() {
    showBetaPreview.value = null
  }

  return {
    showBetaPreview: computed(() => showBetaPreview.value),
    isShowBetaPreviewEnabled,
    setShowBetaPreview,
    clearShowBetaPreview,
  }
})
